import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "@/lib/utils";

const TooltipProvider = (
    props: React.ComponentProps<typeof TooltipPrimitive.Provider>,
) => <TooltipPrimitive.Provider delayDuration={300} {...props} />;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = ({
    className,
    sideOffset = 4,
    ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) => (
    <TooltipPrimitive.Content
        sideOffset={sideOffset}
        className={cn(
            "rounded-narrow text-default-color bg-elevation-surface-raised-default px-narrow py-narrower text-small animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 shadow-overlay z-50 overflow-hidden",
            className,
        )}
        {...props}
    />
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
